export default __webpack_public_path__ + "static/media/low_pink.30d18716.png";